/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map } from 'immutable';
import { putError } from '../store/error.store';
import { RestAPI } from '../util/net';
import { saveFinished, saveInAction } from '../store/allaround.store';

export const cutoffDatesReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'CUTOFF_DATES_UPDATE' :
    case 'CUTOFF_DATES_FETCHED' :
      return state.set(action.variableName, action.value);
    default:
      return state;
  }
};

export const save = (dispatch, variableName, value) => {
  saveInAction(dispatch);
  dispatch({ type: 'CUTOFF_DATES_SAVE_STARTED' });
  return RestAPI.put('/references/systemvalues/api/date'
    + `?variableName=${variableName}&value=${value ? value.getTime() : ''}`)
    .then(() => {
      dispatch({ type: 'CUTOFF_DATES_SAVED' });
      return true;
    },
    (data) => {
      dispatch({ type: 'CUTOFF_DATES_SAVE_FAILED' });
      putError(dispatch, data);
      saveFinished(dispatch);
      return true;
    });
};

export const fetch = (dispatch, variableName) => {
  dispatch({ type: 'CUTOFF_DATES_FETCH_STARTED' });
  return RestAPI.get(`/references/systemvalues/api/date?variableName=${variableName}`)
    .then((value) => {
      if (!value) {
        dispatch({ type: 'CUTOFF_DATES_FETCHED', variableName, value: null });
      } else {
        const day = value.dayOfMonth;
        const month = value.monthValue - 1;
        const year = value.year;
        dispatch({
          type: 'CUTOFF_DATES_FETCHED', variableName,
          value: new Date(Date.UTC(year, month, day)),
        });
      }
      return true;
    },
    (data) => {
      dispatch({ type: 'CUTOFF_DATES_FETCH_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const update = (dispatch, variableName, value) =>
  dispatch({ type: 'CUTOFF_DATES_UPDATE', variableName, value });
